import React,{useEffect} from "react";
import Unity, { UnityContext } from "react-unity-webgl";

const unityContext = new UnityContext({
  loaderUrl: "/teaserCP/Build/teaserCP.loader.js",
  dataUrl: "/teaserCP/Build/teaserCP.data.unityweb",
  frameworkUrl: "/teaserCP/Build/teaserCP.framework.js.unityweb",
  codeUrl: "/teaserCP/Build/teaserCP.wasm.unityweb",
});

function App() {

  return (
    <div><Unity
      style={{
        width:'100%',
        height:'100vh',
        justifyContent:'center',
        alignContent:'center'
      }}
    unityContext={unityContext} /></div>
  )
}

export default App;
